import http from "../http-common";

class AuthService {
  login(email, password) {
    return http.post('/login', { email, password });
  }

  logout() {
    return http.post('/logout');
  }

  me() {
    return http.get('/me');
  }

  refresh() {
    return http.post('/refresh');
  }
}

export default new AuthService();
